module.exports = __webpack_public_path__ + "static/media/wall-safes.85672742.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/model-serial-number/wall-safes.png
// module id = 1302
// module chunks = 0